<template>
  <div class="content">
    <div class="page-title flex align-center just-content-between">
      <div class="flex">
        <p>{{ pageTitle }}</p>
        <p class="u-ml30">{{ tabs + 1 }} / {{ tabsMax + 1 }}</p>
      </div>
      <div class="flex align-center u-ml40 u-mr20" style="font-size: 14px">
        <span class="icon">
          <font-awesome-icon icon="user" size="2x"></font-awesome-icon>
        </span>
        <p class="u-ml5 u-mr10 u-mb0">{{ schoolYear }}</p>
        <p class="u-mb0">{{ childName }}</p>
      </div>
    </div>

    <OrganismsAnchorLink
      :anchorLinks="useDefine.defineObject.NAV_BASIC_SURVEY_1_ANCHORS_ARRAY"
      @goToPageAnchor="goToPage"
    />

    <p class="prohibited-text">
      ※ブラウザの戻るボタン/再読み込みは使用しないでください。<br />入力中のデータが正しく処理されません。
    </p>

    <div class="form-wrap">
      <div class="tab -0" v-show="tabs === 0">
        <!-- 基礎調査資料 start-->
        <section class="form-section">
          <atoms-input-text
            label="事業所名"
            type="text"
            inputmode="text"
            placeholder="〇〇事業所"
            :required="false"
            v-model="formData.officeName"
            setKey="officeName"
            @input-emit="handleUpdateValue"
            :readonly="true"
            :is-edit="true"
          ></atoms-input-text>

          <div class="contents-wrap">
            <atoms-sub-label index="1-2" label="児童" />

            <atoms-input-radio
              label="性別"
              v-model="formData.gender"
              setKey="gender"
              :options="useDefine.defineObject.GENDER_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <div class="d-flex align-items-end flex-contents">
              <atoms-input-select-date
                :date="formData.birthday"
                label="生年月日"
                set-key="birthday"
                :propDefaultYear="new Date().getFullYear() - 5"
                :propDefaultMonth="1"
                :propDefaultDay="1"
                @input-value="handleInputValue"
              />
              <div class="input-wrap u-ml20">
                <label>年齢</label>
                <p style="width: auto;">
                  {{ formData.age !== '' ? formData.age : '-' }}歳
                </p>
              </div>
            </div>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="1-3" label="住所" />

            <atoms-children-zip-input
              class="u-mt15"
              title="郵便番号"
              placeholder="数字のみ"
              keyName="zip"
              v-model="formData.zip"
              description="ハイフンはいりません"
              @input-emit="handleUpdateValue"
              @auto-address="handleSetAddress"
            ></atoms-children-zip-input>

            <AtomsInputSelectTypePrefecture
              label="都道府県"
              v-model="formData.prefecture"
              setKey="prefecture"
              :options="useDefine.defineObject.PREFECTURE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></AtomsInputSelectTypePrefecture>

            <atoms-input-text
              label="市町村"
              type="text"
              inputmode="text"
              placeholder="市町村"
              :required="false"
              v-model="formData.city"
              setKey="city"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>

            <atoms-input-text
              label="番地"
              type="text"
              inputmode="text"
              placeholder="番地"
              :required="false"
              v-model="formData.block"
              setKey="block"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>

            <atoms-input-text
              label="建物名・部屋番号"
              type="text"
              inputmode="text"
              placeholder="建物名・部屋番号"
              :required="false"
              v-model="formData.building"
              setKey="building"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="1-4" label="連絡先" />
            <atoms-input-text
              label="電話番号"
              type="tel"
              inputmode="tel"
              placeholder="数字のみ"
              :required="false"
              :alert="validAlert.tel ? validAlert.tel : false"
              v-model="formData.tel"
              setKey="tel"
              description="ハイフンはいりません"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>

            <atoms-input-textarea
              label="連絡について"
              placeholder="連絡について"
              :required="false"
              v-model="formData.contactInfo"
              setKey="contactInfo"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>
        </section>
      </div>
      <div class="tab -1" v-show="tabs === 1">
        <section class="form-section">
          <atoms-label label="ご相談・ご利用先情報" />
          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="1-5" label="ご相談" />
            <atoms-input-textarea
              label="相談事項"
              placeholder="相談事項"
              :required="false"
              v-model="formData.inquiry"
              setKey="inquiry"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-textarea
              :label="`対象者概要\n(相談経過・現状と課題等)`"
              placeholder="相談経過・現状と課題等"
              :required="false"
              v-model="formData.targetOverview"
              setKey="targetOverview"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-radio
              label="現況"
              v-model="formData.presentSituation"
              setKey="presentSituation"
              :options="useDefine.defineObject.PRESENTSITUATION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-textarea
              label="入院・入所を選択した場合は施設名"
              placeholder="入院・入所を選択した場合は施設名"
              :required="false"
              v-model="formData.presentSituationHospitalizationAdmission"
              setKey="presentSituationHospitalizationAdmission"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>
          <div class="contents-wrap">
            <atoms-sub-label index="1-6" label="通園・通学・就業先" />
            <atoms-input-text
              label="通園先"
              type="text"
              inputmode="text"
              placeholder="通園先"
              :required="false"
              v-model="formData.attendancePlace"
              setKey="attendancePlace"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>
            <atoms-input-text
              label="通学先"
              type="text"
              inputmode="text"
              placeholder="通学先"
              :required="false"
              v-model="formData.currentSchool"
              setKey="currentSchool"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>
            <atoms-input-text
              label="就業先"
              type="text"
              inputmode="text"
              placeholder="就業先"
              :required="false"
              v-model="formData.company"
              setKey="company"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="1-7" label="関係機関との情報共有について" />
            <atoms-input-radio
              label="保健師"
              v-model="formData.nurseInfoSharing"
              setKey="nurseInfoSharing"
              :options="useDefine.defineObject.PROPRIETY_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>
            <atoms-input-radio
              label="保育園・幼稚園"
              v-model="formData.childcareInfoSharing"
              setKey="childcareInfoSharing"
              :options="useDefine.defineObject.PROPRIETY_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>
            <atoms-input-radio
              label="学校"
              v-model="formData.schoolInfoSharing"
              setKey="schoolInfoSharing"
              :options="useDefine.defineObject.PROPRIETY_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-text
              label="計画相談員"
              type="text"
              inputmode="text"
              placeholder="計画相談員 氏名"
              :required="false"
              v-model="formData.consultationSupportResponsible"
              setKey="consultationSupportResponsible"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>
          </div>
        </section>
      </div>
      <div class="tab -2" v-show="tabs === 2">
        <section class="form-section">
          <atoms-label label="ご家族について" />
          <div class="contents-wrap u-mt-0">
            <atoms-sub-label index="1-8" label="世帯形態" />
            <atoms-input-select
              label="世帯形態"
              setKey="householdForm"
              v-model="formData.householdForm"
              :options="useDefine.defineObject.HOUSEHOLDFORM_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>
            <atoms-input-radio
              label="子ども世帯と同居"
              v-model="formData.householdFormLiveWithChildHousehold"
              setKey="householdFormLiveWithChildHousehold"
              :options="useDefine.defineObject.LIVEWITHCHILD_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>
            <atoms-input-radio
              class="w-100"
              label="親族と同居"
              v-model="formData.householdFormLiveWithRelatives"
              setKey="householdFormLiveWithRelatives"
              :options="useDefine.defineObject.LIVEWITHRELATIVES_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>
            <atoms-input-text
              label="単親世帯"
              type="text"
              inputmode="text"
              placeholder="単親世帯"
              :required="false"
              v-model="formData.householdFormSingleParentHouseholds"
              setKey="householdFormSingleParentHouseholds"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>
            <atoms-input-text
              label="その他"
              type="text"
              inputmode="text"
              placeholder="その他"
              :required="false"
              v-model="formData.householdFormOtherwise"
              setKey="householdFormOtherwise"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>
          </div>
          <div class="contents-wrap">
            <atoms-sub-label index="1-9" label="世帯状況" />

            <div>
              <organisms-input-group-array-household-situation
                label="none"
                v-model="formData.householdSituation"
                setArrayKey="householdSituation"
                @input-emit="handleUpdateArrayValue"
                @add-array="handleAddArray"
                @remove-array="handleRemoveArray"
              ></organisms-input-group-array-household-situation>
            </div>
          </div>
        </section>
      </div>
      <div class="tab -3" v-show="tabs === 3">
        <section class="form-section">
          <atoms-label label="発育について" />
          <div class="contents-wrap u-mt-0">
            <atoms-sub-label index="1-10" label="出生期" />

            <div class="input-wrap-group u-mt0">
              <span style="padding-left: 0">第</span>
              <atoms-input-text
                label="none"
                type="text"
                placeholder="1"
                inputmode="numeric"
                :required="false"
                v-model="formData.birthPeriodChildNumber"
                setKey="birthPeriodChildNumber"
                widthClassName="w-smallest"
                @input-emit="handleUpdateValue"
              ></atoms-input-text>
              <span>子</span>
            </div>

            <div class="input-wrap-group u-mt0">
              <atoms-input-text
                label="在胎期間"
                type="text"
                placeholder="40"
                inputmode="numeric"
                :required="false"
                v-model="formData.birthPeriodGestationalAge"
                setKey="birthPeriodGestationalAge"
                widthClassName="w-smallest"
                @input-emit="handleUpdateValue"
              ></atoms-input-text>
              <span>週（月）</span>
            </div>

            <atoms-input-radio
              label="分娩経過"
              v-model="formData.birthPeriodDeliveryElapsed"
              setKey="birthPeriodDeliveryElapsed"
              :options="useDefine.defineObject.DELIVERYELAPSED_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              class="w-100"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-radio
              label="胎位"
              v-model="formData.birthPeriodFetalPosition"
              setKey="birthPeriodFetalPosition"
              :options="useDefine.defineObject.FETALPOSITION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <div class="flex sp-block flex-no-wrap align-end">
              <atoms-input-radio
                label="仮死"
                v-model="formData.birthPeriodApparentDeath"
                setKey="birthPeriodApparentDeath"
                :options="useDefine.defineObject.APPARENTDEATH_OPTION_ARRAY"
                @input-emit="handleUpdateValue"
                :is-tap="true"
              ></atoms-input-radio>
              <div class="input-wrap-group sp-mt-0 sp-ml-0">
                <atoms-input-text
                  class="sp-mt-0 sp-pt-0"
                  label="none"
                  type="text"
                  placeholder="5"
                  inputmode="numeric"
                  :required="false"
                  v-model="formData.birthPeriodMinute"
                  setKey="birthPeriodMinute"
                  widthClassName="w-smallest"
                  @input-emit="handleUpdateValue"
                ></atoms-input-text>
                <span>分</span>
              </div>
            </div>

            <atoms-input-radio
              label="黄疸"
              v-model="formData.birthPeriodJaundice"
              setKey="birthPeriodJaundice"
              :options="useDefine.defineObject.JAUNDICE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              class="w-100"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-radio
              label="哺乳"
              v-model="formData.birthPeriodSuckling"
              setKey="birthPeriodSuckling"
              :options="useDefine.defineObject.SUCKLING_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <div class="input-wrap-group u-mt0">
              <atoms-input-text
                label="出生体重"
                type="text"
                placeholder="3000"
                inputmode="numeric"
                :required="false"
                v-model="formData.birthPeriodBirthWeight"
                setKey="birthPeriodBirthWeight"
                widthClassName="w-smallest"
                @input-emit="handleUpdateValue"
              ></atoms-input-text>
              <span>g</span>
            </div>

            <div class="input-wrap-group u-mt0">
              <atoms-input-text
                label="出生時の身長"
                type="text"
                placeholder="48"
                inputmode="numeric"
                :required="false"
                v-model="formData.birthPeriodHeight"
                setKey="birthPeriodHeight"
                widthClassName="w-smallest"
                @input-emit="handleUpdateValue"
              ></atoms-input-text>
              <span>cm</span>
            </div>

            <div class="input-wrap-group u-mt0">
              <atoms-input-text
                label="頭囲"
                type="text"
                placeholder="48"
                inputmode="numeric"
                :required="false"
                v-model="formData.birthPeriodHeadCircumference"
                setKey="birthPeriodHeadCircumference"
                widthClassName="w-smallest"
                @input-emit="handleUpdateValue"
              ></atoms-input-text>
              <span>cm</span>
            </div>

            <atoms-input-textarea
              :label="`指摘事項・その他`"
              placeholder="指摘事項・その他"
              :required="false"
              v-model="formData.birthPeriodFindingsAndOther"
              setKey="birthPeriodFindingsAndOther"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="1-11" label="胎生期" />
            <atoms-input-textarea
              label="妊娠の経過、感染症など"
              placeholder="妊娠の経過、感染症など"
              :required="false"
              v-model="formData.embryonal"
              setKey="embryonal"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>
          <div class="contents-wrap">
            <atoms-sub-label index="1-12" label="乳幼児期" />
            <div class="input-wrap-group u-mt0">
              <atoms-input-text
                label="首すわり"
                type="text"
                inputmode="numeric"
                placeholder="5"
                min="0"
                :required="false"
                v-model="formData.earlyChildhoodNeckStability"
                setKey="earlyChildhoodNeckStability"
                widthClassName="w-smallest"
                @input-emit="handleUpdateValue"
              ></atoms-input-text>
              <span>ヶ月</span>
            </div>
            <div class="input-wrap-group u-mt0">
              <atoms-input-text
                label="ハイハイ"
                type="text"
                inputmode="numeric"
                placeholder="5"
                min="0"
                :required="false"
                v-model="formData.earlyChildhoodCrawlStart"
                setKey="earlyChildhoodCrawlStart"
                widthClassName="w-smallest"
                @input-emit="handleUpdateValue"
              ></atoms-input-text>
              <span>ヶ月</span>
            </div>
            <div class="input-wrap-group u-mt0">
              <atoms-input-text
                label="寝返り"
                type="text"
                inputmode="numeric"
                placeholder="5"
                min="0"
                :required="false"
                v-model="formData.earlyChildhoodRollStart"
                setKey="earlyChildhoodRollStart"
                widthClassName="w-smallest"
                @input-emit="handleUpdateValue"
              ></atoms-input-text>
              <span>ヶ月</span>
            </div>
            <div class="input-wrap-group u-mt0">
              <atoms-input-text
                label="おすわり"
                type="text"
                inputmode="numeric"
                placeholder="5"
                min="0"
                :required="false"
                v-model="formData.earlyChildhoodSedentary"
                setKey="earlyChildhoodSedentary"
                widthClassName="w-smallest"
                @input-emit="handleUpdateValue"
              ></atoms-input-text>
              <span>ヶ月</span>
            </div>

            <div class="input-wrap-group u-mt0">
              <atoms-input-text
                label="初歩"
                type="text"
                inputmode="numeric"
                placeholder="5"
                min="0"
                :required="false"
                v-model="formData.earlyChildhoodWalkFirstTime"
                setKey="earlyChildhoodWalkFirstTime"
                widthClassName="w-smallest"
                @input-emit="handleUpdateValue"
              ></atoms-input-text>
              <span>ヶ月</span>
            </div>
            <div class="input-wrap-group u-mt0">
              <atoms-input-text
                label="始語（有意味語）"
                type="text"
                inputmode="numeric"
                placeholder="5"
                min="0"
                :required="false"
                v-model="formData.earlyChildhoodFirstWords"
                setKey="earlyChildhoodFirstWords"
                widthClassName="w-smallest"
                @input-emit="handleUpdateValue"
              ></atoms-input-text>
              <span>ヶ月</span>
            </div>
          </div>
        </section>
      </div>
      <div class="tab -4" v-show="tabs === 4">
        <section class="form-section">
          <atoms-label label="保険証・手帳等情報" />
          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="1-13" label="手帳" />
            <atoms-input-check-box
              setKey="notebookInformationKindOfNotebook"
              :options="useDefine.defineObject.KINDOFNOTEBOOK_OPTION_ARRAY"
              label="お持ちの手帳の種類"
              v-model="formData.notebookInformationKindOfNotebook"
              @input-emit="handleUpdateValue"
              class="w-100"
              :is-tap="true"
            ></atoms-input-check-box>

            <div
              v-for="option in formData.notebookInformationKindOfNotebook"
              :key="option.id"
            >
              <div class="form-content u-mt30" v-if="option === '身障手帳'">
                <p class="form-content-title">身障手帳</p>

                <atoms-input-radio
                  label="手帳の申請状況"
                  v-model="
                    formData.notebookInformationHandicappedNotebookPresentSituation
                  "
                  setKey="notebookInformationHandicappedNotebookPresentSituation"
                  :options="
                    useDefine.defineObject.APPLICATIONNOTEBOOK_OPTION_ARRAY
                  "
                  class="w-100"
                  @input-emit="handleUpdateValue"
                  :is-tap="true"
                ></atoms-input-radio>

                <atoms-input-text
                  label="診断名"
                  type="text"
                  inputmode="text"
                  placeholder="診断名"
                  :required="false"
                  v-model="
                    formData.notebookInformationHandicappedNotebookFailureName
                  "
                  setKey="notebookInformationHandicappedNotebookFailureName"
                  @input-emit="handleUpdateValue"
                ></atoms-input-text>

                <atoms-input-text
                  label="判定（診断）機関"
                  type="text"
                  inputmode="text"
                  placeholder="判定（診断）機関"
                  :required="false"
                  v-model="
                    formData.notebookInformationHandicappedNotebookDecisionAgency
                  "
                  setKey="notebookInformationHandicappedNotebookDecisionAgency"
                  @input-emit="handleUpdateValue"
                ></atoms-input-text>

                <div class="flex align-end">
                  <atoms-input-text
                    label="種"
                    type="text"
                    inputmode="text"
                    placeholder="種"
                    :required="false"
                    v-model="
                      formData.notebookInformationHandicappedNotebookSeed
                    "
                    setKey="notebookInformationHandicappedNotebookSeed"
                    widthClassName="w-smallest"
                    @input-emit="handleUpdateValue"
                  ></atoms-input-text>
                  <p class="u-ml5 u-mr15">種</p>

                  <atoms-input-select
                    label="級"
                    setKey="notebookInformationHandicappedNotebookGrade"
                    :options="
                      useDefine.defineObject
                        .PHYSICALDISABILITYNOTEBOOK_SELECT_OPTION_ARRAY
                    "
                    v-model="
                      formData.notebookInformationHandicappedNotebookGrade
                    "
                    @input-emit="handleUpdateValue"
                  ></atoms-input-select>
                </div>

                <div
                  class="input-wrap flex align-end sp-flexwrap w-100 flex-no-wrap"
                >
                  <atoms-input-text
                    class="sp-full sp-mb-0"
                    label="発行した自治体"
                    type="text"
                    inputmode="text"
                    placeholder="都道府県名・市町村名"
                    :required="false"
                    v-model="
                      formData.notebookInformationHandicappedNotebookPrefecturalAndCityText
                    "
                    setKey="notebookInformationHandicappedNotebookPrefecturalAndCityText"
                    @input-emit="handleUpdateValue"
                  ></atoms-input-text>

                  <atoms-input-radio
                    class="sp-ml-0 sp-label-top sp-full u-ml15"
                    label="none"
                    v-model="
                      formData.notebookInformationHandicappedNotebookPrefecturalAndCity
                    "
                    setKey="notebookInformationHandicappedNotebookPrefecturalAndCity"
                    :options="
                      useDefine.defineObject.PREFECTUALANDCITY_OPTION_ARRAY
                    "
                    @input-emit="handleUpdateValue"
                  ></atoms-input-radio>
                </div>

                <atoms-input-text
                  label="No."
                  type="text"
                  inputmode="text"
                  placeholder="No."
                  :required="false"
                  v-model="formData.notebookInformationHandicappedNotebookNo"
                  setKey="notebookInformationHandicappedNotebookNo"
                  widthClassName="w-smallest"
                  @input-emit="handleUpdateValue"
                ></atoms-input-text>

                <atoms-input-select-date
                  :date="formData.notebookInformationHandicappedDeliveryDate"
                  label="交付日"
                  set-key="notebookInformationHandicappedDeliveryDate"
                  @input-value="handleInputValue"
                />
              </div>

              <div
                class="form-content u-mt30"
                v-if="option === '精神保健福祉手帳'"
              >
                <p class="form-content-title">精神保健福祉手帳</p>

                <atoms-input-radio
                  label="手帳の申請状況"
                  v-model="
                    formData.notebookInformationMentalHealthNotebookPresentSituation
                  "
                  setKey="notebookInformationMentalHealthNotebookPresentSituation"
                  :options="
                    useDefine.defineObject.APPLICATIONNOTEBOOK_OPTION_ARRAY
                  "
                  @input-emit="handleUpdateValue"
                  class="w-100"
                  :is-tap="true"
                ></atoms-input-radio>

                <atoms-input-text
                  label="診断名"
                  type="text"
                  inputmode="text"
                  placeholder="診断名"
                  :required="false"
                  v-model="
                    formData.notebookInformationMentalHealthNotebookDiagnosis
                  "
                  setKey="notebookInformationMentalHealthNotebookDiagnosis"
                  @input-emit="handleUpdateValue"
                ></atoms-input-text>

                <atoms-input-text
                  label="判定（診断）機関"
                  type="text"
                  inputmode="text"
                  placeholder="判定（診断）機関"
                  :required="false"
                  v-model="
                    formData.notebookInformationMentalHealthNotebookDecisionAgency
                  "
                  setKey="notebookInformationMentalHealthNotebookDecisionAgency"
                  @input-emit="handleUpdateValue"
                ></atoms-input-text>

                <atoms-input-select
                  label="級"
                  setKey="notebookInformationMentalHealthNotebookGrade"
                  :options="
                    useDefine.defineObject
                      .MENTALHEALTHNOTEBOOK_SELECT_OPTION_ARRAY
                  "
                  v-model="
                    formData.notebookInformationMentalHealthNotebookGrade
                  "
                  @input-emit="handleUpdateValue"
                ></atoms-input-select>

                <atoms-input-select-date
                  :date="
                    formData.notebookInformationMentalHealthNotebookDeliveryDate
                  "
                  label="交付日"
                  set-key="notebookInformationMentalHealthNotebookDeliveryDate"
                  @input-value="handleInputValue"
                />
              </div>

              <div class="form-content u-mt30" v-if="option === '愛の手帳'">
                <p class="form-content-title">愛の手帳</p>

                <atoms-input-radio
                  label="手帳の申請状況"
                  v-model="formData.LoveOfTheNotebookPresentSituation"
                  setKey="LoveOfTheNotebookPresentSituation"
                  :options="
                    useDefine.defineObject.APPLICATIONNOTEBOOK_OPTION_ARRAY
                  "
                  @input-emit="handleUpdateValue"
                  class="w-100"
                  :is-tap="true"
                ></atoms-input-radio>

                <atoms-input-text
                  label="診断名"
                  type="text"
                  inputmode="text"
                  placeholder="診断名"
                  :required="false"
                  v-model="formData.LoveOfTheNotebookPresentName"
                  setKey="LoveOfTheNotebookPresentName"
                  @input-emit="handleUpdateValue"
                ></atoms-input-text>

                <atoms-input-text
                  label="判定（診断）機関"
                  type="text"
                  inputmode="text"
                  placeholder="判定（診断）機関"
                  :required="false"
                  v-model="formData.LoveOfTheNotebookJudgmentAgencies"
                  setKey="LoveOfTheNotebookJudgmentAgencies"
                  @input-emit="handleUpdateValue"
                ></atoms-input-text>

                <atoms-input-text
                  label="程度"
                  type="text"
                  inputmode="text"
                  placeholder="程度"
                  :required="false"
                  v-model="formData.LoveOfTheNotebookDegree"
                  setKey="LoveOfTheNotebookDegree"
                  @input-emit="handleUpdateValue"
                ></atoms-input-text>

                <div
                  class="input-wrap flex align-end sp-flexwrap w-100 flex-no-wrap"
                >
                  <atoms-input-text
                    class="sp-full sp-mb-0"
                    label="発行した自治体"
                    type="text"
                    inputmode="text"
                    placeholder="都道府県名・市町村名"
                    :required="false"
                    v-model="formData.LoveOfTheNotebookPrefecturalAndCityText"
                    setKey="LoveOfTheNotebookPrefecturalAndCityText"
                    @input-emit="handleUpdateValue"
                  ></atoms-input-text>

                  <atoms-input-radio
                    class="sp-ml-0 sp-label-top sp-full u-ml15"
                    label="none"
                    v-model="formData.LoveOfTheNotebookPrefecturalAndCity"
                    setKey="LoveOfTheNotebookPrefecturalAndCity"
                    :options="
                      useDefine.defineObject.PREFECTUALANDCITY_OPTION_ARRAY
                    "
                    @input-emit="handleUpdateValue"
                  ></atoms-input-radio>
                </div>

                <atoms-input-text
                  label="No."
                  type="text"
                  inputmode="text"
                  placeholder="No."
                  :required="false"
                  v-model="formData.LoveOfTheNotebookNumber"
                  setKey="LoveOfTheNotebookNumber"
                  widthClassName="w-smallest"
                  @input-emit="handleUpdateValue"
                ></atoms-input-text>

                <atoms-input-select-date
                  :date="formData.LoveOfTheNotebookDeliveryDate"
                  label="交付日"
                  set-key="LoveOfTheNotebookDeliveryDate"
                  @input-value="handleInputValue"
                />

                <atoms-input-select-date
                  :date="formData.LoveOfTheNotebookNextDecisionDate"
                  label="次回判定年月"
                  set-key="LoveOfTheNotebookNextDecisionDate"
                  @input-value="handleInputValue"
                />
              </div>
            </div>
          </div>
          <!-- 手帳はここ -->

          <div class="contents-wrap">
            <atoms-sub-label index="1-14" label="健康保険証" />

            <atoms-input-radio
              label="健康保険"
              v-model="formData.healthInsurance"
              setKey="healthInsurance"
              :options="useDefine.defineObject.HEALTHINSURANCE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              class="w-100"
              :is-tap="true"
            ></atoms-input-radio>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="1-15" label="要介護度" />
            <atoms-input-radio
              label="要介護"
              v-model="formData.levelOfCareRequiredStatus"
              setKey="levelOfCareRequiredStatus"
              :options="useDefine.defineObject.APPLICABLE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>
            <template v-for="option in formData.levelOfCareRequiredStatus">
              <div
                class="form-content u-mt30"
                :key="option.id"
                v-if="option === '該当'"
              >
                <p class="form-content-title">
                  該当の場合こちらを入力してください
                </p>

                <atoms-input-text
                  label="診断名"
                  type="text"
                  inputmode="text"
                  placeholder="診断名"
                  :required="false"
                  v-model="formData.levelOfCareRequiredText"
                  setKey="levelOfCareRequiredText"
                  @input-emit="handleUpdateValue"
                ></atoms-input-text>

                <atoms-input-text
                  label="判定（診断）機関"
                  type="text"
                  inputmode="text"
                  placeholder="判定（診断）機関"
                  :required="false"
                  v-model="formData.levelOfCareRequiredDecisionAgency"
                  setKey="levelOfCareRequiredDecisionAgency"
                  @input-emit="handleUpdateValue"
                ></atoms-input-text>

                <div class="flex align-end flex-no-wrap">
                  <atoms-input-select-date
                    :date="
                      formData.levelOfCareRequiredCertificationExpirationDate
                    "
                    label="認定有効期限"
                    set-key="levelOfCareRequiredCertificationExpirationDate"
                    @input-value="handleInputValue"
                  />
                  <p>まで</p>
                </div>

                <atoms-input-text
                  label="被保険者番号"
                  type="text"
                  inputmode="text"
                  placeholder="12"
                  :required="false"
                  v-model="formData.levelOfCareRequiredInsuredNumber"
                  setKey="levelOfCareRequiredInsuredNumber"
                  @input-emit="handleUpdateValue"
                ></atoms-input-text>

                <atoms-input-radio
                  label="要介護度の申請状況"
                  v-model="formData.levelOfCareRequired"
                  setKey="levelOfCareRequired"
                  :options="
                    useDefine.defineObject.APPLICATIONNOTEBOOK_OPTION_ARRAY
                  "
                  @input-emit="handleUpdateValue"
                  class="w-100"
                  :is-tap="true"
                ></atoms-input-radio>
              </div>
            </template>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="1-16" label="障害支援区分" />
            <atoms-input-radio
              label="障害支援"
              v-model="formData.DisabilityStatus"
              setKey="DisabilityStatus"
              :options="useDefine.defineObject.APPLICABLE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>
            <template v-for="option in formData.DisabilityStatus">
              <div
                class="form-content u-mt30"
                :key="option.id"
                v-if="option === '該当'"
              >
                <p class="form-content-title">
                  該当の場合こちらを入力してください
                </p>
                <atoms-input-text
                  label="診断名"
                  type="text"
                  inputmode="text"
                  placeholder="診断名"
                  :required="false"
                  v-model="formData.DisabilityText"
                  setKey="DisabilityText"
                  @input-emit="handleUpdateValue"
                ></atoms-input-text>
                <atoms-input-text
                  label="診断（判定）機関"
                  type="text"
                  inputmode="text"
                  placeholder="診断（判定）機関"
                  :required="false"
                  v-model="formData.DisabilityDecisionAgency"
                  setKey="DisabilityDecisionAgency"
                  @input-emit="handleUpdateValue"
                ></atoms-input-text>
                <div class="flex align-end flex-no-wrap">
                  <atoms-input-select-date
                    :date="formData.DisabilityCertificationExpirationDate"
                    label="認定有効期限"
                    set-key="DisabilityCertificationExpirationDate"
                    @input-value="handleInputValue"
                  />
                  <p>まで</p>
                </div>
                <atoms-input-radio
                  label="障害支援区分の申請状況"
                  v-model="formData.Disability"
                  setKey="Disability"
                  :options="
                    useDefine.defineObject.APPLICATIONNOTEBOOK_OPTION_ARRAY
                  "
                  @input-emit="handleUpdateValue"
                  class="w-100"
                  :is-tap="true"
                ></atoms-input-radio>
              </div>
            </template>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="1-17" label="収入" />
            <atoms-input-radio
              class="u-mt20 w-100"
              label="主な収入"
              setKey="healthInsuranceMainIncome"
              v-model="formData.healthInsuranceMainIncome"
              :options="useDefine.defineObject.MAININCOME_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <template v-for="option in formData.healthInsuranceMainIncome">
              <div
                class="form-content u-mt30"
                :key="option.id"
                v-if="option === '年金'"
              >
                <p class="form-content-title">
                  年金を選択した場合こちらを入力してください
                </p>

                <div class="contents-wrap flex align-end u-mt0">
                  <atoms-input-text
                    label="年金の種類"
                    type="text"
                    inputmode="text"
                    placeholder="年金"
                    :required="false"
                    v-model="formData.healthInsuranceMainIncomePension"
                    setKey="healthInsuranceMainIncomePension"
                    @input-emit="handleUpdateValue"
                  ></atoms-input-text>
                  <p class="u-mb0 u-ml10 u-mr10">年金</p>
                  <atoms-input-text
                    class="sp-mt-0"
                    label=""
                    type="text"
                    inputmode="text"
                    placeholder="級"
                    :required="false"
                    v-model="formData.healthInsuranceMainIncomePensionGrade"
                    setKey="healthInsuranceMainIncomePensionGrade"
                    widthClassName="w-smallest"
                    @input-emit="handleUpdateValue"
                  ></atoms-input-text>
                  <p class="u-mb0 u-ml10 u-mr10">級</p>
                </div>
              </div>

              <div
                class="form-content u-mt30"
                :key="option.id"
                v-if="option === 'その他'"
              >
                <p class="form-content-title">
                  その他を選択した場合こちらを入力してください
                </p>
                <atoms-input-textarea
                  label="その他"
                  placeholder="その他"
                  :required="false"
                  v-model="formData.healthInsuranceMainIncomeOther"
                  setKey="healthInsuranceMainIncomeOther"
                  @input-emit="handleUpdateValue"
                ></atoms-input-textarea>
              </div>
            </template>
          </div>
        </section>
      </div>
      <div class="tab -5" v-show="tabs === 5">
        <section class="form-section">
          <atoms-label label="既往・現病歴・支援の状況" />
          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="1-18" label="既往・現病歴" />

            <organisms-input-group-array-medical-history
              label="none"
              v-model="formData.medicalHistory"
              setArrayKey="medicalHistory"
              :dataMax="5"
              @input-emit="handleUpdateArrayValue"
              @add-array="handleAddArray"
              @remove-array="handleRemoveArray"
            >
            </organisms-input-group-array-medical-history>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="1-19" label="支援の状況" />

            <p class="u-mb0 u-mt10" style="font-size: 14px">
              ※公的支援(障害福祉サービス、地域相談支援、介護保険等）及びその他の支援状況について記載
            </p>
            <organisms-input-group-array-status-of-support
              label="none"
              v-model="formData.statusOfSupport"
              setArrayKey="statusOfSupport"
              :dataMax="5"
              @input-emit="handleUpdateArrayValue"
              @add-array="handleAddArray"
              @remove-array="handleRemoveArray"
            ></organisms-input-group-array-status-of-support>

            <atoms-input-textarea
              label="備考"
              placeholder="備考"
              :required="false"
              v-model="formData.remarks"
              setKey="remarks"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>
        </section>
      </div>
      <!-- 基礎調査資料 end-->
      <div class="check_button_wrap prev_and_next">
        <div class="prev">
          <atoms-note-button
            v-if="tabs > tabsMin"
            buttonText="前の項目へ"
            @confirm="handlePrevTabs"
          />
        </div>
        <div class="next">
          <atoms-note-button
            v-if="tabs < tabsMax"
            buttonText="次の項目へ"
            @confirm="handleNextTabs"
          />
        </div>
      </div>
    </div>
    <div class="form-tabs" v-if="nextPageTitle">
      <atoms-note-button
        :buttonText="`${nextPageTitle}へ`"
        @confirm="handleUpdateFormTab"
      />
    </div>
  </div>
</template>

<script>
import { defineObject } from '@/lib/define/use-define'
import formUtils from '@/lib/formUtils/form-utils'
import organismsInputGroupArrayHouseholdSituation from '@/components/organisms/OrganismsInputGroupArrayHouseholdSituation.vue'
import organismsInputGroupArrayMedicalHistory from '@/components/organisms/OrganismsInputGroupArrayMedicalHistory.vue'
import organismsInputGroupArrayStatusOfSupport from '@/components/organisms/OrganismsInputGroupArrayStatusOfSupport.vue'
import OrganismsAnchorLink from '@/components/organisms/basicSurvey/OrganismsAnchorLink.vue'
import AtomsLabel from '@/components/plugins/atoms/AtomsLabel.vue'
export default {
  components: {
    organismsInputGroupArrayHouseholdSituation,
    organismsInputGroupArrayMedicalHistory,
    organismsInputGroupArrayStatusOfSupport,
    OrganismsAnchorLink,
    AtomsLabel,
  },
  data() {
    return {
      tabsMin: 0,
      tabsMax: 5,
      tabs: 0,
      // formの選択肢
      useDefine: { defineObject: defineObject },
      validAlert: {},
      validArray: [
        'parentsFirstName1',
        'parentsLastName1',
        'parentsFirstKana1',
        'parentsLastKana1',
        'lastName',
        'firstName',
        'paymentAmount',
        'beneficiaryId',
        'tel',
      ],
      // emit対象のformデータ
      formData: {
        parentsFirstName1: '',
        parentsLastName1: '',
        parentsFirstKana1: '',
        parentsLastKana1: '',
        paymentAmount: '',
        beneficiaryId: '',
        officeName: '',
        createdDate: '',
        lastUpdate: '',
        consultationSupportResponsible: '',
        lastName: '',
        firstName: '',
        lastKana: '',
        firstKana: '',
        gender: '',
        birthday: '',
        birthdayJapaneseCalendar: '',
        age: '',
        zip: '',
        prefecture: '',
        city: '',
        block: '',
        building: '',
        tel: '',
        profession: '',
        presentSituation: '',
        presentSituationHospitalizationAdmission: '',
        targetOverview: '',
        notebookInformationKindOfNotebook: [],
        // 身障手帳：
        notebookInformationHandicappedNotebookPresentSituation: '',
        notebookInformationHandicappedNotebookFailureName: '',
        notebookInformationHandicappedNotebookDecisionAgency: '', //リニューアル追加
        notebookInformationHandicappedNotebookSeed: '',
        notebookInformationHandicappedNotebookGrade: '',
        notebookInformationHandicappedNotebookPrefecturalAndCity: '',
        notebookInformationHandicappedNotebookPrefecturalAndCityText: '',
        notebookInformationHandicappedNotebookNo: '',
        notebookInformationHandicappedDeliveryDate: '',
        // 精神保健福祉手帳：
        notebookInformationMentalHealthNotebookPresentSituation: '',
        notebookInformationMentalHealthNotebookGrade: '',
        notebookInformationMentalHealthNotebookDeliveryDate: '',
        notebookInformationMentalHealthNotebookDiagnosis: '',
        notebookInformationMentalHealthNotebookDecisionAgency: '',
        // 愛の手帳：
        LoveOfTheNotebookPresentName: '',
        LoveOfTheNotebookPresentSituation: '',
        LoveOfTheNotebookPrefecturalAndCity: '',
        LoveOfTheNotebookPrefecturalAndCityText: '',
        LoveOfTheNotebookNumber: '',
        LoveOfTheNotebookDeliveryDate: '',
        LoveOfTheNotebookDegree: '',
        LoveOfTheNotebookNextDecisionDate: '',
        LoveOfTheNotebookJudgmentAgencies: '',
        // 障害者情報：
        disabilityInformation: '',
        disabilityInformationOtherwise: '',
        otherwiseDecisionInstitutions: '',
        // 要介護度
        levelOfCareRequiredText: '',
        levelOfCareRequiredCertificationExpirationDate: '',
        levelOfCareRequiredInsuredNumber: '',
        levelOfCareRequired: '',
        levelOfCareRequiredStatus: '',
        levelOfCareRequiredDecisionAgency: '',
        // 障害支援区分
        DisabilityText: '',
        DisabilityCertificationExpirationDate: '',
        DisabilityInsuredNumber: '',
        Disability: '',
        DisabilityStatus: '',
        DisabilityDecisionAgency: '',
        // 健康保険：
        healthInsurance: '',
        healthInsuranceMainIncome: '',
        healthInsuranceMainIncomePension: '',
        healthInsuranceMainIncomePensionGrade: '',
        healthInsuranceMainIncomeOther: '',
        // 世帯形態
        householdForm: '',
        householdFormLiveWithChildHousehold: '',
        householdFormLiveWithRelatives: '',
        householdFormSingleParentHouseholds: '',
        householdFormOtherwise: '',
        // 世帯状況
        householdSituation: [],
        familyOverview: '',
        statusOfSupport: [],
        remarks: '',
        // リニューアル新規追加
        contactInfo: '',
        inquiry: '',
        attendancePlace: '',
        currentSchool: '',
        company: '',
        nurseInfoSharing: '',
        childcareInfoSharing: '',
        schoolInfoSharing: '',
        birthPeriodChildNumber: '',
        birthPeriodGestationalAge: '',
        birthPeriodDeliveryElapsed: '',
        birthPeriodFetalPosition: '',
        birthPeriodApparentDeath: '',
        birthPeriodMinute: '',
        birthPeriodJaundice: '',
        birthPeriodSuckling: '',
        birthPeriodBirthWeight: '',
        birthPeriodHeight: '',
        birthPeriodHeadCircumference: '',
        birthPeriodFindingsAndOther: '',
        embryonal: '',
        earlyChildhoodSedentary: '',
        earlyChildhoodWalkFirstTime: '',
        earlyChildhoodFirstWords: '',
        earlyChildhoodNeckStability: '',
        earlyChildhoodCrawlStart: '',
        earlyChildhoodRollStart: '',
        medicalHistory: [],
      },
    }
  },
  props: {
    propsFormData: {
      type: Object,
      required: true,
    },
    setObjectKey: {
      type: String,
      required: true,
    },
    pageTitle: {
      type: String,
      required: true,
    },
    nextPageTitle: {
      type: String,
      required: false,
    },
    childName: {
      type: String,
      required: false,
    },
    schoolYear: {
      type: String,
      required: false,
    },
  },
  methods: {
    handleValiCheck() {
      this.validArray.forEach(targeKey => {
        const emptyCheckArrayKey = [
          'parentsFirstName1',
          'parentsLastName1',
          'parentsFirstKana1',
          'parentsLastKana1',
          'lastName',
          'firstName',
        ]

        this.validAlert[targeKey] = false

        // 必須入力のみバリデーション
        if (
          this.formData[targeKey] === '' &&
          emptyCheckArrayKey.includes(targeKey)
        ) {
          this.validAlert[targeKey] = true
        }

        const regexpKana = /[\u{3000}-\u{301C}\u{3041}-\u{3093}\u{309B}-\u{309E}]/mu

        // かなバリデーション
        if (
          targeKey.includes('Kana') &&
          !regexpKana.test(this.formData[targeKey])
        ) {
          this.validAlert[targeKey] = true
        }

        // 半角数字バリデーション
        const regexpNumeric = /^[0-9]*$/
        const numericCheckArrayKey = ['paymentAmount', 'beneficiaryId', 'tel']

        if (
          numericCheckArrayKey.includes(targeKey) &&
          !regexpNumeric.test(this.formData[targeKey])
        ) {
          this.validAlert[targeKey] = true
        }
      })
    },
    handleUpdateArrayValue(setArrayKey, setKey, index, setValue) {
      this.formData[setArrayKey][index][setKey] = setValue
      this.handleUpdateValue(setArrayKey, this.formData[setArrayKey])
    },
    handleAddArray(setArrayKey, targetValue) {
      this.formData[setArrayKey].push(targetValue)
      this.handleUpdateValue(setArrayKey, this.formData[setArrayKey])
    },
    handleRemoveArray(setArrayKey, targetIndex) {
      this.formData[setArrayKey].splice(targetIndex, 1)
      this.handleUpdateValue(setArrayKey, this.formData[setArrayKey])
    },
    handleUpdateValue(setKey, setVal) {
      // if (setKey === 'birthday') {
      //   this.formData.birthdayJapaneseCalendar = formUtils.handleSetJapaneseCalendar(
      //     setVal
      //   )
      //   this.$emit(
      //     'input',
      //     this.setObjectKey,
      //     'birthdayJapaneseCalendar',
      //     this.formData.birthdayJapaneseCalendar
      //   )

      //   this.handleSetAge(new Date(), setVal)
      // }
      this.formData[setKey] = setVal

      this.handleValiCheck()

      this.$emit('input-emit', this.setObjectKey, setKey, setVal)
    },
    handleInputValue(value, key) {
      if (key === 'birthday') {
        this.formData.birthdayJapaneseCalendar = formUtils.handleSetJapaneseCalendar(
          value
        )
        this.$emit(
          'input-emit',
          this.setObjectKey,
          'birthdayJapaneseCalendar',
          this.formData.birthdayJapaneseCalendar
        )

        this.handleSetAge(new Date(), value)
      }
      const date = `${value.getFullYear()}-${value.getMonth() +
        1}-${value.getDate()}`
      this.formData[key] = date
      this.$emit('input-emit', this.setObjectKey, key, date)
    },
    handleSetAge(targetdate, birthdate) {
      birthdate = new Date(birthdate)
      let age = targetdate.getFullYear() - birthdate.getFullYear()
      const birthday = new Date(
        targetdate.getFullYear(),
        birthdate.getMonth(),
        birthdate.getDate()
      )
      if (targetdate < birthday) {
        age--
      }

      this.formData.age = age
      this.$emit('input-emit', this.setObjectKey, 'age', age)
    },
    handleSetAddress(address) {
      if (address) {
        this.formData.prefecture = address.prefcode
        this.handleUpdateValue('prefecture', this.formData.prefecture)

        this.formData.city = address.ja.address1

        this.handleUpdateValue('city', this.formData.city)

        this.formData.block = address.ja.address2

        this.handleUpdateValue('block', this.formData.block)
      }
    },
    handlePrevTabs() {
      this.handleSmoothScroll()
      this.tabs--
    },
    handleNextTabs() {
      this.handleSmoothScroll()
      this.tabs++
    },
    handleSmoothScroll() {
      this.$smoothScroll({
        scrollTo: document.getElementById('app'), // scrollTo is also allowed to be number
      })
    },
    handleUpdateFormTab() {
      this.$emit('click-tab-switch', this.setObjectKey)
    },
    goToPage(tab) {
      this.tabs = tab
    },
  },
  mounted() {
    Object.keys(this.formData).forEach(key => {
      if (this.propsFormData[key]) {
        this.formData[key] = this.propsFormData[key]
      }

      this.handleUpdateValue(key, this.formData[key])
    })

    if (!this.formData.createdDate) {
      this.formData.createdDate = formUtils.handleSetJapaneseCalendar(
        new Date(),
        '',
        'none'
      )
      this.handleUpdateValue('createdDate', this.formData.createdDate)
    }

    this.handleValiCheck()
  },
}
</script>
<style lang="scss" scoped>
.form-tabs {
  margin: 0 auto;
  max-width: 460px;
  button {
    width: 100%;
  }
}
p {
  margin: 0;
}
</style>
